import { Box } from '@mui/material'

import ToothGraphic2 from '@/assets/images/Tooth-graphic-2.svg'
import ToothGraphic4 from '@/assets/images/Tooth-graphic-4.svg'
import ToothGraphic5 from '@/assets/images/Tooth-graphic-5.svg'
import ToothGraphic6 from '@/assets/images/Tooth-graphic-6.svg'

function ImageContainer({ selectedTab }: { selectedTab?: string }) {
  return (
    <Box
      flex={3}
      display="flex"
      justifyContent="center"
      alignItems="center"
      margin="auto"
      sx={{ minWidth: '316px' }}
    >
      {selectedTab === 'Stump Shade' && (
        <img style={{ width: '85%' }} src={ToothGraphic6} alt="Toothimage" />
      )}
      {(selectedTab === 'Wash Bake' || selectedTab === 'Staining') && (
        <img style={{ width: '85%' }} src={ToothGraphic5} alt="Toothimage" />
      )}
      {selectedTab === 'Dentin' && (
        <img style={{ width: '85%' }} src={ToothGraphic4} alt="Toothimage" />
      )}
      {selectedTab === 'Enamel' && (
        <img style={{ width: '85%' }} src={ToothGraphic2} alt="Toothimage" />
      )}
    </Box>
  )
}

export default ImageContainer
